import React from 'react';
import styled from 'styled-components';
import { Checkbox } from 'libs/forms/styles';

const SubtemplateList = props => {
  const { updateSelectedSubsections, selectedSubsections } = props;

  const subsectionsKeys = Object.keys(selectedSubsections);

  const subtemplateChecked = subtemplate_id => {
    updateSelectedSubsections(
      subtemplate_id,
      !selectedSubsections[subtemplate_id].isSelected,
    );
  };

  const subsectionViews = [];

  for (let i = 0; i < subsectionsKeys.length; i += 1) {
    const subsectionInfo = selectedSubsections[subsectionsKeys[i]];

    subsectionViews.push(
      <SubtemplateEntry
        key={`subs-${i}`}
        className='subsection-entry'
        style={
          selectedSubsections[subsectionsKeys[i]].isSelected === true
            ? { color: '#0F2EFF' }
            : { color: '#000000' }
        }
      >
        <SubtemplateTitle>{subsectionInfo.title}</SubtemplateTitle>

        <SubtemplateCheckboxHolder>
          <Checkbox
            id={`cb-${subsectionsKeys[i]}`}
            type='checkbox'
            checked={selectedSubsections[subsectionsKeys[i]].isSelected}
            onChange={() => subtemplateChecked(subsectionsKeys[i])}
          />
        </SubtemplateCheckboxHolder>
        <SubtemplateDescription>
          {subsectionInfo.description
            ? subsectionInfo.description
            : 'Description to be detailed'}
        </SubtemplateDescription>
      </SubtemplateEntry>,
    );
  }

  return <div>{subsectionViews}</div>;
};

export default SubtemplateList;

const SubtemplateEntry = styled.div`
  display: grid;
  margin: 0.25rem auto;
  grid-template-columns: 2;
  margin-bottom: 15px;
  padding: 0px 75px;
  font-family: HelveticaNowDisplay;
`;

const SubtemplateTitle = styled.h4`
  grid-row: 1;
  grid-column: 1;
  margin-bottom: 15px;
  font-weight: 100;
  font-size: 18px;
`;

const SubtemplateDescription = styled.p`
  grid-row:2;
  grid-column-1;
  font-weight: 100;
  font-size: 16px;
  margin-bottom:20px;
`;

const SubtemplateCheckboxHolder = styled.div`
  grid-row: 2;
  grid-column: 2;
`;
